






















































import { Component, Vue } from 'vue-property-decorator';

import APIService from '@/api';
import SignupService from '@/api/SingupService';

import Surface from '@/components/atoms/Surface/Surface.vue';
import Picture from '@/components/atoms/Picture/Picture.vue';
import Typography from '@/components/atoms/Typography/Typography.vue';
import OutlinedButton from '@/components/molecules/OutlinedButton/OutlinedButton.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';

import { clearSessionSignup } from './session';
import { removeOauthState } from '@/router/router-utils';
import { insideProviderIframe } from '@/utils/providerIframe';
import WaitingForApproval from './Steps/WaitingForApproval.vue';

@Component({
  components: {
    Surface,
    Picture,
    Typography,
    OutlinedButton,
    FilledButton,
    WaitingForApproval
  }
})
export default class Signup extends Vue {
  service = new SignupService();

  get isInsideIframe(): boolean {
    return insideProviderIframe();
  }

  get ManagerCredentials() {
    return this.$store.getters['manager/getExtraInfo'];
  }

  logout() {
    if (!this.isInsideIframe) {
      removeOauthState();
    }
    clearSessionSignup();
    APIService.resetCredentials();
    window.location.assign('/');
  }

  goToDashboard() {
    this.$router.push('/');
  }

  back() {
    this.$ga.event({
      eventCategory: 'signup-create-account',
      eventAction: 'click-close'
    });

    this.$router.back();
  }

  buttonClick() {
    if (this.ManagerCredentials) {
      if (this.ManagerCredentials.requireBusiness) {
        APIService.resetCredentials();
      } else {
        window.location.assign('/');
      }
    } else {
      this.$router.push('login');
    }
  }
}
